module.exports = __webpack_public_path__ + "img/learning-platforms.f3c10e97.svg";